"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastProviderMixin = void 0;
var _drywall = require("drywall");
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
var ALIGN = {
  'top-start': 'flex-start',
  'top': 'center',
  'top-end': 'flex-end',
  'bottom-start': 'flex-start',
  'bottom': 'center',
  'bottom-end': 'flex-end'
};

/** @class ToastProviderMixin */
/** @method */
var ToastProviderMixin = function ToastProviderMixin(props) {
  var placement = props.placement;
  return (0, _styledToken.default)({
    zIndex: 'Toast.Provider.zIndex',
    margin: 'Toast.margin',
    animatedListMargin: 'Toast.animatedList.margin',
    animatedListPadding: 'Toast.animatedList.padding'
  }, function (_ref) {
    var zIndex = _ref.zIndex,
      margin = _ref.margin,
      _ref$animatedListMarg = _ref.animatedListMargin,
      animatedListMargin = _ref$animatedListMarg === void 0 ? 0 : _ref$animatedListMarg,
      _ref$animatedListPadd = _ref.animatedListPadding,
      animatedListPadding = _ref$animatedListPadd === void 0 ? 0 : _ref$animatedListPadd;
    return (0, _styledComponents.css)(["position:fixed;", ":0;right:0;left:0;z-index:", ";pointer-events:none;", "{pointer-events:auto;margin:", ";margin-", ":0;}", "{margin:", "px;padding:", "px;list-style:none;display:flex;flex-direction:column", ";align-items:", ";}", "{position:relative;}"], placement.indexOf('top') === 0 ? 'top' : 'bottom', zIndex, _drywall.Toast, margin ? margin + "px" : (0, _spaceMixin.spaceMixin)('sm')(props), placement.indexOf('top') === 0 ? 'bottom' : 'top', _drywall.AnimatedList, animatedListMargin, animatedListPadding, placement.indexOf('top') === 0 ? '-reverse' : '', ALIGN[placement], _drywall.AnimatedList.Item);
  })(props);
};
exports.ToastProviderMixin = ToastProviderMixin;